<template>
  <div class="support-fab" :class="{ 'support-fab--hide': hidden }">
    <button
      class="support-fab__btn"
      type="button"
      @click="goChat"
      aria-label="แชทกับเจ้าหน้าที่"
      title="แชทกับเจ้าหน้าที่"
    >
      <i class="fa fa-headphones support-fab__icon" aria-hidden="true"></i>
      <span class="support-fab__text">แชท</span>
    </button>
  </div>
</template>

<script>
export default {
    name: 'SupportFab',
    props: {
    // ถ้าคุณอยากซ่อนตอนเปิด modal/บางสถานะ ให้ส่ง hidden มาคุมได้
        hidden: {
            type: Boolean,
            default: false,
        },
        to: {
            type: String,
            default: '/chat',
        },
    },
    methods: {
        goChat() {
            // ใช้ router push ไป /chat
            this.$router.push(this.to)
        },
    },
}
</script>

<style scoped>
/* container fixed */
.support-fab {
  position: fixed;
  right: 18px;
  bottom: 18px;
  z-index: 9999;

  /* กันปุ่มไปทับ home indicator บางเครื่อง */
  padding-bottom: env(safe-area-inset-bottom);
  pointer-events: none; /* ให้คลิกได้เฉพาะปุ่ม */
}

.support-fab--hide {
  display: none;
}

/* button */
.support-fab__btn {
  pointer-events: auto;
  display: inline-flex;
  align-items: center;
  gap: 10px;

  border: 0;
  border-radius: 999px;
  padding: 12px 14px;

  /* โทนสีฟ้า */
  background: linear-gradient(180deg, #034c13, #036c46);
  color: #fff;

  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.25);
  cursor: pointer;

  transition: transform 0.08s ease, box-shadow 0.12s ease, opacity 0.12s ease;
  user-select: none;
}

.support-fab__btn:hover {
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.30);
}

.support-fab__btn:active {
  transform: translateY(1px);
}

.support-fab__icon {
  font-size: 20px;
  line-height: 1;
}

.support-fab__text {
  font-weight: 900;
  letter-spacing: 0.2px;
  font-size: 14px;
}

/* Tablet (iPad) */
@media (min-width: 768px) {
  .support-fab {
    right: 22px;
    bottom: 22px;
  }
  .support-fab__btn {
    padding: 14px 16px;
  }
  .support-fab__icon {
    font-size: 22px;
  }
  .support-fab__text {
    font-size: 15px;
  }
}

/* Mobile: ทำให้ “แตะง่าย” + เป็นวงกลมถ้าจอแคบมาก */
@media (max-width: 420px) {
  .support-fab {
    right: 14px;
    bottom: 14px;
  }
  .support-fab__btn {
    padding: 14px;
    gap: 0;
    width: 54px;
    height: 54px;
    justify-content: center;
  }
  .support-fab__text {
    display: none;
  }
  .support-fab__icon {
    font-size: 22px;
  }
}
</style>